<template>
  <div class="corrigendumRecord">
    <div class="title">
      <div class="mainTitle">
        勘误记录
      </div>
    </div>
    <el-table
    
      v-loading="listLoading"
      :data="list"
      fit
      highlight-current-row
      empty-text=" "
      style="width: 100%;"
    >
      <el-table-column label="生成时间" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.createDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="数据来源" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160px" align="center">
        <template slot-scope="scope">
          <span class="detail" @click="handleDetail(scope.row)">详情</span>
        </template>
      </el-table-column>
    </el-table>
    <NoData top="-260px" v-if="list.length===0"/>
  </div>
</template>

<script>
import { corrigendaRecord } from "@/api/corrigenda";
import Back from '../../components/Back.vue';
import NoData from '../../components/NoData.vue';
export default {
  components: { Back, NoData },
  filters: {
    statusFilter(status) {
      const statusMap = {
        WAIT: "待处理",
        PROCESSED: "已处理"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      CovertableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-08",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-06",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-07",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        }
      ],
      list: [],
      listLoading: false,
      listQuery: {
        current: 1,
        size: 10
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      corrigendaRecord(this.listQuery).then(res => {
        console.log(res);
        this.list = res.data.d.records;
      });
    },
    handleDetail(row){
      // this.$router.push({path:'corrigendumDetail',query:{id}})
      this.$router.push({path:'corrigendumDetail'})
      localStorage.setItem('corrigendumDetail',JSON.stringify(row))
    }
  }
};
</script>

<style scoped lang="scss">
.corrigendumRecord {
  display: flex;
  margin-top: 39px;
  flex: 1;
  margin-bottom: 70px;
  background: #fff;
  margin-left: 17px;
  padding: 38px 41px 60px 40px;
  flex-direction: column;
  min-height: 702px;
  box-sizing: border-box;
  // .el-table {
  //   thead {
  //     tr {
  //       th {
  //         .el-table__cell {
  //           background-color: #f0f2f5;
  //         }
  //       }
  //     }
  //   }
  // }
  .el-table th.el-table__cell {
    background-color: #f0f2f5;
  }
  // .title {
  //   margin-bottom: 22px;
  //   font-weight: bold;
  // }
  .detail {
    color: #338ff7;
    cursor: pointer;
  }
  .title {
    margin-bottom: 22px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    .mainTitle {
      display: flex;
      align-items: center;
      &::before {
        content: "";
        border-left: 3px solid #3a61b1;
        padding-right: 10px;
        height: 16px;
        position: relative;
        top: 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/CorrigendumRecord.vue